import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';

const initialState = {
    isSubmit: false,
    isFail: false,
    isGetItem: false,
    isFetchingUpdate: false,
    dataList: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    isFetchSyncAll: false,
    isFetchSync: false,
    isFetching: false,
    dataListRateByHotels: [],
    isFetchingRatesByHotels: false,
    isFetchingCancelPolicy: false,
    isFetchActive: false,
    isFetchExtend: false,
    dataSync: [],
    dataSyncLanguage: [],
    priceConfig: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.RATE_LIST_ACTION:
            return { ...state, isFetching: true, dataList: [] };
        case Types.HOTEL_DETAIL_SUCCESS:
            return { ...state, pageIndex: PAGINATION.pageIndex, }
        case Types.RATE_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false,
                dataList: action.dataList,
                isSubmit: false,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.RATE_LIST_FAIL:
            return { ...state, isFetching: false };
        case Types.RATE_DETAIL_ACTION:
            return { ...state, isFetching: true, rate: {} };
        case Types.RATE_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false,
                rate: action.rate
            };
        case Types.RATE_DETAIL_FAIL:
            return { ...state, isFetching: false };
        case Types.RATE_SAVE_ACTION:
            return { ...state, isFetching: true };
        case Types.RATE_SAVE_SUCCESS:
            return {
                ...state,
                isFetching: false,
                rate: action.rate
            };

        case Types.RATE_SAVE_FAIL:
            return { ...state, isFetching: false, rate: action.rate };
        case Types.RATE_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.RATE_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.RATE_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.RATE_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.RATE_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.RATE_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.RATE_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isFetched: true, isFetchActive: false, isFetchSync: false, isFetchSyncAll: false };
        case Types.RATE_SYNC_ALL_HOTELS_ACTION:
            return { ...state, isFetchSyncAll: true };
        case Types.RATE_SYNC_ALL_HOTELS_SUCCESS:
            return { ...state, isFetchSyncAll: false };
        case Types.RATE_SYNC_ALL_GOLF_ACTION:
            return { ...state, isFetchSyncAll: true };
        case Types.RATE_SYNC_ALL_GOLF_SUCCESS:
            return { ...state, isFetchSyncAll: false };
        case Types.RATE_SYNC_RATES_ACTION:
            return { ...state, isFetchSync: true };
        case Types.RATE_SYNC_RATES_SUCCESS:
            return { ...state, isFetchSync: false, dataSync: action.result };
        case Types.RATE_LIST_BY_HOTELS_ACTION:
            return {
                ...state,
                isFetchingRatesByHotels: true,
                dataListRateByHotels: []
            };
        case Types.RATE_LIST_BY_HOTELS_FAIL:
            return {
                ...state,
                isFetchingRatesByHotels: false,
            }
        case Types.RATE_LIST_BY_HOTELS_SUCCESS:
            return {
                ...state,
                isFetchingRatesByHotels: false,
                dataListRateByHotels: action.dataListRateByHotels.data,
            };
        case Types.CANCEL_POLICY_UPDATE_ACTION:
            return { ...state, isFetchingCancelPolicy: true };
        case Types.CANCEL_POLICY_UPDATE_SUCCESS:
            return { ...state, isFetchingCancelPolicy: false };
        case Types.CANCEL_POLICY_SYNC_ACTION:
            return { ...state, isFetchingCancelPolicy: true };
        case Types.CANCEL_POLICY_SYNC_SUCCESS:
            return { ...state, isFetchingCancelPolicy: false };
            
        case Types.RATE_UPDATE_ACTIVE_ACTION:
            return { ...state, isFetchActive: true };
        case Types.RATE_UPDATE_ACTIVE_SUCCESS:
            return { ...state, isFetchActive: false };
        case Types.RATE_UPDATE_EXTEND_ACTION: 
            return {...state, isFetchExtend: true}
        case Types.RATE_UPDATE_EXTEND_SUCCESS: 
            return {...state, isFetchExtend: false};
        case Types.RATE_USAGE_STATUS_ACTION:
            return { ...state, isFetchSyncAll: true };
        case Types.RATE_USAGE_STATUS_SUCCESS:
            return { ...state, isFetchSyncAll: false };

        case Types.SYNC_RATE_LANGUAGE_ACTION:
            return {...state, dataSyncLanguage: [], isFetching: true};
        case Types.SYNC_RATE_LANGUAGE_SUCCESS:
            return {...state, dataSyncLanguage: [], isFetching: false};
        case Types.SYNC_RATE_LANGUAGE_FAIL:
            return {...state, dataSyncLanguage: action.data, isFetching: false};

        case Types.CANCEL_POLICY_FAIL:
            return { ...state, isFetchingCancelPolicy: false, isFetchSyncAll: false };
        
        case Types.PRICE_CONFIG_LIST_ACTION:
            return { ...state, isFetching: true, priceConfig: [] };
        case Types.PRICE_CONFIG_LIST_SUCCESS:
            return { ...state, isFetching: false, priceConfig: action.dataList };
        default:
            return state;
    }
}
